import { Configuration, LogLevel, PopupRequest } from '@azure/msal-browser';
import { API_BASE } from './apiBase';

// Coffee Run MSAL Configuration - Original Implementation
export const msalConfig: Configuration = {
  auth: {
    clientId:
      import.meta.env.VITE_AAD_CLIENT_ID ||
      '2a08cd80-e0cf-4d60-8edd-ebb0d9aa4a27',
    authority:
      import.meta.env.VITE_AAD_AUTHORITY ||
      'https://login.microsoftonline.com/consumers', // Use 'consumers' for personal Microsoft accounts ONLY
    redirectUri:
      import.meta.env.VITE_REDIRECT_URI || `${window.location.origin}/`,
    postLogoutRedirectUri:
      import.meta.env.VITE_REDIRECT_URI || `${window.location.origin}/`,
    navigateToLoginRequestUrl: false, // Important for SPA
    clientCapabilities: ['CP1'], // This enables SPA flow
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0,
    allowNativeBroker: false, // Disable native broker for web
    loggerOptions: {
      loggerCallback: (_level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        console.log(`[MSAL] ${message}`);
      },
      logLevel: LogLevel.Info,
      piiLoggingEnabled: false,
    },
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: ['User.Read'],
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const apiConfig = {
  baseUrl: API_BASE, // Absolute URL until Functions backend is linked to SWA
  endpoints: {
    ping: '/ping',
    runs: '/runs',
    orders: '/orders',
    receipts: '/receipts',
  },
};
